import FileUpload from '~/scripts/services/model/file-upload';
import APIV5 from '~/models/api';
import PdfUtils from '~/components/pdf/pdf-utils';
import Defaults from '~/scripts/constants/defaults';
import angular from 'angular';

/* globals Knitiv */

export default class KformTabFileMultipleController {
	#$injector;

	#$location;

	#$rootScope;

	#$scope;

	#$timeout;

	#$translate;

	#FileDownloadService;

	#NodeService;

	#Notification;

	/**
	 *
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').ILocationService} $location
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {any} FileDownloadService
	 * @param {any} NodeService
	 * @param {any} Notification
	 * @param {any} User
	 * @param {import('angular').ISCEService} $sce
	 */

	/* @ngInject */
	constructor(
		$injector,
		$location,
		$rootScope,
		$scope,
		$timeout,
		$translate,
		FileDownloadService,
		NodeService,
		Notification,
		User,
		$sce,
	) {
		this.#$injector = $injector;
		this.#$location = $location;
		this.#$rootScope = $rootScope;
		this.#$scope = $scope;
		this.#$timeout = $timeout;
		this.#$translate = $translate;
		this.#FileDownloadService = FileDownloadService;
		this.#NodeService = NodeService;
		this.#Notification = Notification;
		this.$sce = $sce;

		this.Defaults = Defaults;

		this.pdfUtils = new PdfUtils($injector);

		this.content = undefined;
		this.disabled = undefined;

		/** @type {boolean} */
		this.kds = this.#$rootScope.kds;

		/** @type {?import('~/components/kform/kform.controller').default} */
		this.kform = null;

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.kid = null;

		/** @type {?import('~/scripts/services/model/form').default} */
		this.form = null;

		/** @type {string} */
		this.fileActiveId = 'new';

		// /** @type {import('@knitiv/api-client-javascript').FileInfo[]} */
		/** @type {import('~/scripts/services/model/file-upload').default[]} */
		this.files = [];

		this.htmlPreviewInitializing = undefined;

		/** @type {boolean} */
		this.isAdmin = !!User.getProfil().admin;

		this.jsonEditorDefaultOptions = {
			readOnly: {
				mode:  'view',
				modes: [
					'view',
				],
			},
			edit:     {
				mode:  'tree',
				modes: [
					'tree',
					'view',
					'form',
					'code',
					'text',
				],
			},
		};
		this.jsonEditorOptions = {};
		this.loading = true;

		/** @type {?Function} */
		this.onLoad = null;

		/** @type {import('~/scripts/services/model/file-upload').default} */
		this.tmpFile = new FileUpload(this.#$injector);
	}

	/**
	 * Adds a file to the current form
	 *
	 * @param {File} file File instance
	 * @param {?string} id File id (for kds) - if supplied, then replace it
	 */
	async addFile(file, id = null) {
		const fileUpload = await this.form?.addFile(file, id);
		if (fileUpload && id === null) {
			this.fileActiveId = fileUpload.id;
			this.#$location.search({
				tab: 'file',
				id:  this.fileActiveId,
			});
		}
	}

	/**
	 * @param {File[]} files
	 * @returns {Promise<any>}
	 */
	async addFiles(files) {
		/**
		 * @type {string | undefined}
		 */
		let lastFileActiveId;
		for (const file of files) {
			const fileUpload = await this.form?.addFile(file);
			if (fileUpload) {
				lastFileActiveId = fileUpload.id;
			}
		}
		this.#$timeout(() => {
			if (lastFileActiveId) {
				this.fileActiveId = lastFileActiveId;
				this.#$location.search({
					tab: 'file',
					id:  this.fileActiveId,
				});
			}
		});
	}

	/**
	 * Set node file to html viewer in order to open the RTF editor
	 */
	create() {
		if (!this.tmpFile.file) {
			this.htmlPreviewInitializing = false;
		}
		this.tmpFile.loaded = 0;
		if (this.form) {
			this.form.isfile = true;
			// this.form.viewer_engine = 'html';
		}
	}

	/**
	 * Removes a file from the specified form
	 *
	 * @param {import('~/scripts/services/model/file-upload').default} file
	 */
	async detachFile(file) {
		if (this.form) {
			await this.form.detachFile(file);
		}
	}

	/**
	 * Downloads the file of the current form
	 */
	download() {
		if (this.form?.checkDroit(Defaults.DROIT.READ)) {
			this.#FileDownloadService
				.download([{ kid: this.kid }])
				.catch((/** @type {any} */ error) => {
					console.error(error);
				});
		}
	}

	/**
	 * @param {any} file
	 * @returns {string}
	 */
	getThumb(file) {
		let returnValue = '';
		if ('thumb_icon' in file && file.thumb_icon) {
			returnValue = file.thumb_raw
				? file.thumb_icon
				: `data:${file.thumb_mimetype || 'image/png'};base64,${file.thumb_icon}`;
		}
		return returnValue;
	}

	/**
	 * Loads the file for preview it
	 *
	 * @returns {Promise<any>} Promise result
	 */
	async loadFiles() {
		if (this.kid) {
			if (this.kds) {
				const infos = await APIV5.instance.fileInfoMultiple(
					{
						nodeid: this.kid,
						type:   'viewer',
					},
					{
						id: 'kform-tab-file.load-file',
					},
				);
				this.files = infos.files.map((/** @type {any} */ f) => {
					const file = new FileUpload(
						this.#$injector,
						f,
						f.name.user,
					);
					file.loaded = file.file.size;
					return file;
				});
				this.#$timeout(() => {
					this.setFileActiveId();
				});
			}
			else {
				const infos = await APIV5.instance.fileInfo(
					{
						nodeid: this.kid,
						type:   'viewer',
					},
					{
						id: 'kform-tab-file.load-file',
					},
				);
				this.files = [new FileUpload(this.#$injector, infos)];
			}

			// const viewer = getType(infos.mimetype);
			// const render = getRender(viewer);
			//
			// if (viewer !== 'binary') {
			// 	this.form.viewer_engine = viewer;
			// }
			// if (!this.form?.viewer_mimetype) {
			// 	this.form.viewer_mimetype = this.infos.mimetype;
			// }

			// let url;
			// let data;

			// /** @type {import('@knitiv/api-client-javascript').DownloadInput} */
			// const options = {
			// 	nodeid: this.kid,
			// 	inline: true,
			// 	mode:   'all_in_once',
			// 	type:   'viewer',
			// };

			// switch (render) {
			// case 'inline': {
			// 	url = APIV5.instance.downloadURL(options);
			// 	break;
			// }
			// case 'custom': {
			// 	const dl = await APIV5.instance.download(options);
			// 	data = dl.buffer;
			// 	url = URL.createObjectURL(new Blob([data], { type: this.infos.mimetype }));
			// 	break;
			// }
			// case 'none': {
			// 	this.file.loaded = true;
			// 	break;
			// }
			// default: {
			// 	url = null;
			// }
			// }

			// if (url) {
			// 	const r = /\.([^.])+$/.exec(this.infos.name);
			// 	let extension = null;
			//
			// 	switch (viewer) {
			// 	case 'mail': {
			// 		this.file.url = data;
			// 		break;
			// 	}
			//
			// 	case 'pdf': {
			// 		this.file.url = this.trustSrc(url);
			// 		this.file.kid = this.kid;
			// 		break;
			// 	}
			//
			// 	case 'zip': {
			// 		this.file.loaded = true;
			// 		try {
			// 			this.file.url = JSON.parse(new TextDecoder('utf8').decode(data));
			// 		}
			// 		catch (error) {
			// 			console.error(error);
			// 			this.form.viewer_engine = null;
			// 		}
			// 		break;
			// 	}
			//
			// 	case 'json': {
			// 		try {
			// 			this.file.url = JSON.parse(new TextDecoder('utf8').decode(data));
			// 		}
			// 		catch (error) {
			// 			console.error(error);
			// 			this.form.viewer_engine = null;
			// 		}
			// 		break;
			// 	}
			//
			// 	case 'text': {
			// 		try {
			// 			this.file.url = new TextDecoder('utf8').decode(data);
			// 		}
			// 		catch (error) {
			// 			console.error(error);
			// 			this.form.viewer_engine = null;
			// 		}
			//
			// 		if (r && r[1]) {
			// 			extension = r[1];
			// 		}
			//
			// 		for (const definition of Object.values(aceModeDefs)) {
			// 			if ('mimetypes' in definition && Array.isArray(definition.mimetypes)) {
			// 				for (const mimetype of definition.mimetypes) {
			// 					if (mimetype === this.file.file.type) {
			// 						// TODO: Set correct text mode using a compartment for language
			// 					}
			// 				}
			// 			}
			// 			if (extension && 'ext' in definition && Array.isArray(definition.ext)) {
			// 				for (const definitionExtension of definition.ext) {
			// 					if (definitionExtension === extension) {
			// 						// TODO: Set correct text mode
			// 					}
			// 				}
			// 			}
			// 		}
			// 		if (this.file.file.type === 'text/html') {
			// 			// TODO: Set correct text mode
			// 		}
			// 		break;
			// 	}
			//
			// 	case 'html': {
			// 		this.file.url = new TextDecoder('utf8').decode(data);
			// 		this.kform?.renderFileAsHTML(this.file.url);
			// 		break;
			// 	}
			//
			// 	case 'image': {
			// 		this.file.url = {
			// 			rotate: 0,
			// 			url:    this.trustSrc(url),
			// 		};
			// 		break;
			// 	}
			//
			// 	case 'video': {
			// 		this.file.url = this.trustSrc(url);
			// 		break;
			// 	}
			//
			// 	default: {
			// 		this.form.viewer_engine = null;
			// 	}
			// 	}
			//
			// 	if (viewer === 'pdf' && url) {
			// 		const resultPromise = await fetch(url);
			// 		const pdf = await resultPromise.arrayBuffer();
			// 		this.file.signatures = this.pdfUtils.getSignatures(pdf);
			// 	}
			//
			// 	this.#$timeout(() => {
			// 		this.file.loaded = true;
			// 	});
			// 	if (this.kform?.backupFile) {
			// 		this.kform?.backupFile(this.kid);
			// 	}
			// 	if (typeof this.onLoad === 'function') {
			// 		this.onLoad();
			// 	}
			// }
		}
	}

	/**
	 * @param {any} file
	 */
	openSignatures(file) {
		this.pdfUtils.showModalSignatures(file.signatures);
	}

	/**
	 * Prints the current form
	 */
	// eslint-disable-next-line class-methods-use-this
	print() {
		const divContents = angular.element('body');

		divContents.addClass('print-html');
		window.print();
		divContents.removeClass('print-html');
	}

	async relaunchKonvProcess() {
		const node = await this.#NodeService.load(this.form?.kid);
		const attribut = node.attribut.find((/** @type {any} */ a) => a.name === 'F_KONV_STATUS');
		attribut.value = 'TO_PROCESS';
		node.modAttribute(attribut);
		await this.#NodeService.update(node);
		this.#Notification.success({
			title:   this.#$translate.instant('object.successfully-updated-title'),
			message: this.#$translate.instant('object.successfully-updated-message'),
		});
	}

	/**
	 * Rotates the image in preview file
	 *
	 * @param {any} file
	 */
	rotate(file) {
		const object = file.url;
		switch (object.rotate) {
		case 0: {
			object.rotate = 90;
			break;
		}

		case 90: {
			object.rotate = 180;
			break;
		}

		case 180: {
			object.rotate = 270;
			break;
		}

		default: {
			object.rotate = 0;
		}
		}
	}

	setFileActiveId() {
		this.fileActiveId = this.#$location.search().id ?? (this.files.length > 0 ? this.files[0].file.id : 'new');
	}

	/**
	 * @param {string} source
	 * @returns {Promise<any>}
	 */
	trustSrc(source) {
		return this.$sce.trustAsResourceUrl(source);
	}

	/**
	 * @param {import('angular').IOnChangesObject} changes
	 */
	$onChanges(changes) {
		if (changes.disabled) {
			this.jsonEditorOptions = changes.disabled.currentValue
				? this.jsonEditorDefaultOptions.readOnly : this.jsonEditorDefaultOptions.edit;
		}

		if (changes.form && this.form && Array.isArray(this.files)) {
			// this.tmpFile = new FileUpload(this.#$injector, {
			// 	size: this.form.getAttribute('F_SIZE')?.value,
			// 	type: this.form.getAttribute('F_MIMETYPE')?.value,
			// 	name: this.form.getAttribute('F_FILENAME')?.value,
			// });
			// this.tmpFile.uploaded = true;
			if (this.files.length === 0) {
				(async () => this.loadFiles())();
			}
			else {
				this.setFileActiveId();
			}
		}
	}

	$onInit() {
		this.htmlPreviewInitializing = true;
		if (this.form?.kid) {
			this.kid = this.form.kid;
		}
		this.#$scope.$on('Form.submitted', () => {
			this.form?.formScope?.kformForm?.$setPristine();
			this.form?.formScope?.kformForm?.$setUntouched();
		});

		this.#$scope.$on('$locationChangeSuccess', () => {
			this.setFileActiveId();
		});

		this.#$scope.$on('Form.change-tab', () => {
			// for (const file of this.files) {
			// 	if (file?.loaded) {
			// 		file.loaded = false;
			// 		this.#$timeout(() => {
			// 			file.loaded = true;
			// 		});
			// 	}
			// }
		});

		this.loading = false;
	}
}
